<app-link
    [link]="url"
    [title]="itinerary?.title"
    (mouseenter)="preloadItinerary(itinerary)"
    (touchstart)="preloadItinerary(itinerary)">
    <article
        class="flex h-full flex-col rounded-fa bg-white text-darkgrey shadow transition duration-200 hover:cursor-pointer hover:shadow-xl">
        <div class="aspect-h-1 aspect-w-2 flex-grow-0">
            <div>
                <div class="relative h-full">
                    <app-lazy-asset
                        [configuration]="featuredImageConfiguration"
                        [additionalClasses]="['rounded-t-fa']"></app-lazy-asset>
                    <div
                        class="absolute bottom-4 left-4 z-10 rounded-lg bg-red px-3 py-2 text-white">
                        From
                        {{
                            itinerary?.startingPrice
                                | currency: 'USD' : 'symbol' : '1.0-0'
                        }}
                    </div>
                </div>
            </div>
        </div>
        <div class="items-between flex flex-grow flex-col justify-between p-6">
            <div class="pb-4">
                <h3>{{ itinerary?.title }}</h3>
                <p class="text-sm text-deemphasized">
                    {{ itinerary?.shortDescription }}
                </p>
            </div>
            <div>
                <p class="mb-4">
                    <fa-icon [icon]="faClock"></fa-icon>
                    {{ itinerary?.daysCollection?.total }} days
                </p>
                <div class="flex space-x-4">
                    <app-star-rating
                        class="block"
                        [additionalClasses]="['text-red']"
                        [rating]="
                            itinerary?.averageReviewRating || 0
                                | number: '1.0-0'
                        "></app-star-rating>
                    <p>
                        ({{
                            itinerary?.averageReviewRating || 0
                                | number: '1.1-1'
                        }})
                    </p>
                </div>
            </div>
        </div>
    </article>
</app-link>
